import { type ButtonHTMLAttributes, forwardRef } from "react";
import { cn } from "./cn";
import { Tooltip } from "./tooltip";

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  active?: boolean;
  tooltipSide?: "top" | "right" | "bottom" | "left";
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ label, active, tooltipSide = "top", className, children, ...props }, ref) => {
    return (
      <Tooltip label={label} side={tooltipSide}>
        <button
          ref={ref}
          type="button"
          aria-label={label}
          aria-current={active ? "page" : undefined}
          className={cn(
            "inline-flex size-9 items-center justify-center rounded-md transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--focus)] disabled:opacity-50 [&_svg]:size-[18px]",
            active
              ? "bg-[var(--accent)]/15 text-[var(--accent)]"
              : "text-[var(--fg-muted)] hover:bg-[var(--surface)] hover:text-[var(--fg)]",
            className,
          )}
          {...props}
        >
          {children}
        </button>
      </Tooltip>
    );
  },
);
IconButton.displayName = "IconButton";
